import { useEffect } from 'react';
import { Button } from './components/Utility/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setError } from './Store/Actions/errorActions';

export default function Error() {
    const errorRedirectCounter = useSelector((state: any) => state.error.errorRedirectCounter);
    const errorMessage = useSelector((state: any) => state.error.errorMessage);
    const errorStatus = useSelector((state: any) => state.error.status);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    let timeout = errorRedirectCounter <= 10 ? 10000 : 10000 + 10000 * (errorRedirectCounter - 10);
    useEffect(() => {
        if (errorStatus !== 404) {
            const interval = setInterval(async () => {
                localStorage.setItem(
                    'errorRedirectCounter',
                    (parseInt(errorRedirectCounter.toString()) + 1).toString(),
                );
                window.location.reload();
            }, timeout);
            return () => clearInterval(interval);
        }
    });

    return (
        <div className="absolute h-screen w-screen overflow-hidden bg-[#fff] z-[100] gap-3 text-black flex justify-center items-center flex-col text-2xl">
            <p>ERROR</p>
            {errorMessage !== '' && <p>{errorMessage}</p>}
            {errorStatus === 404 ? (
                <Button
                    onClick={() => {
                        dispatch(setError(false));
                        navigate('/');
                    }}
                >
                    Zur Startseite
                </Button>
            ) : (
                <Button onClick={() => window.location.reload()}>Reload</Button>
            )}
        </div>
    );
}
